import { useState, useEffect } from "react";
import { getDefectClasses } from "../pages/ReportDetails/api";

const EMPTY_SIDE = { classes: [], colors: {}, rawToOutput: {} };

export const useDefectClasses = () => {
  const [data, setData] = useState({
    external: EMPTY_SIDE,
    internal: EMPTY_SIDE,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getDefectClasses();
        if (cancelled) return;
        if (!res?.status || !res?.models) {
          throw new Error("Unexpected defect_classes response shape");
        }
        setData({
          external: {
            classes: res.models.external?.classes || [],
            colors: res.models.external?.colors || {},
            rawToOutput: res.models.external?.raw_to_output || {},
          },
          internal: {
            classes: res.models.internal?.classes || [],
            colors: res.models.internal?.colors || {},
            rawToOutput: res.models.internal?.raw_to_output || {},
          },
          loading: false,
          error: null,
        });
      } catch (err) {
        console.error("Error fetching defect classes:", err);
        if (!cancelled) {
          setData((prev) => ({ ...prev, loading: false, error: err }));
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const classesForSide = (side) => data[side]?.classes || [];
  const colorForSide = (side, name) => data[side]?.colors?.[name] ?? "#ef4444";

  return { ...data, classesForSide, colorForSide };
};